export default __webpack_public_path__ + "static/media/logo.518d1dee.svg";